let _routes = [];

/**
 * Object to store routes
 * @type {Object}
 */
const routes = {
  register(routesArray) {
    _routes = _routes.concat(routesArray);
  },
  list() {
    return _routes;
  },
};

export default routes;
